import React, { createContext, useContext, useState } from 'react';

// Create the context
const PaymentContext = createContext();

// Create a provider component
export const PaymentProvider = ({ children }) => {
  const [paymentData, setPaymentData] = useState(null);

  // Function to set payment data
  const setOrderForPayment = (orderItems, userSessionId) => {
    setPaymentData({
      orderItems,
      userSessionId,
      timestamp: Date.now()
    });
  };

  // Function to clear payment data
  const clearPaymentData = () => {
    setPaymentData(null);
  };

  // Check if we have valid payment data
  const hasValidPaymentData = () => {
    if (!paymentData) return false;
    
    // Check if the payment data is still valid (less than 10 minutes old)
    const orderTime = paymentData.timestamp || 0;
    const currentTime = Date.now();
    const timeDifference = currentTime - orderTime;
    const tenMinutesInMs = 10 * 60 * 1000;
    
    return timeDifference < tenMinutesInMs;
  };

  return (
    <PaymentContext.Provider value={{ 
      paymentData, 
      setOrderForPayment, 
      clearPaymentData,
      hasValidPaymentData
    }}>
      {children}
    </PaymentContext.Provider>
  );
};

// Custom hook to use the payment context
export const usePayment = () => useContext(PaymentContext);
